import { Component, ContentChild, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { fadeIn, fadeOut } from 'src/app/animations';

@Component({
	selector: 'generic-modal',
	templateUrl: './generic-modal.component.html',
	styleUrls: ['./generic-modal.component.scss'],
	animations: [fadeIn(300), fadeOut(300)]
})
export class GenericModalComponent implements OnInit {

	@ContentChild('modalHeading') modalHeading: TemplateRef<any>;
	@ContentChild('modalBody') modalBody: TemplateRef<any>;
	@ContentChild('modalActions') modalActions: TemplateRef<any>;

	@Input() public isPredefinedOpen = false;
	@Input() public predefinedData: any;
	@Input() hideOnBackdropClick = true;
	@Input() public isFullHeight = false;
	@Input() public overlayClass: string = '';

	@Input() private onHide: () => void;

	@Output() public onBackdropClick = new EventEmitter<void>();

	public isOpen = false;
	public data: any;

	constructor() { }

	ngOnInit(): void {
	}

	public open(data?: any): void {
		this.isOpen = true;
		this.data = data;
	}

	public hide(): void {
		this.isOpen = false;
		this.isPredefinedOpen = false;
		this.data = null;
		this.onBackdropClick.emit();

		if (this.onHide) {
			this.onHide();
		}
	}
}
